import "@/helpers/turbo"
import CompetitionFormController from "../controllers/competition_form_controller"
import RecaptchaController from "../controllers/recaptcha_controller"

import InputValidityController from "../controllers/forms/input_validity_controller"

import { register } from "@/helpers/stimulus"

const setupStimulus = (): void => {
  register("competition-form", CompetitionFormController)
  register("input-validity", InputValidityController)
  register("recaptcha", RecaptchaController)
}

setupStimulus()
